<span *ngIf="rating!=undefined" class="rating">
  <i *ngFor="let i of [0,1,2,3,4]" [ngClass]="{'fas':i<rating,'far':i>=rating, 'fa-star':true}"></i>
</span>
<span *ngIf="rating==undefined">—</span>